import { useTranslation } from 'react-i18next';

import { getLocalizedSpeciality } from '@virtual-care/isomorphic';

import { useLanguage } from '../../../i18n/use-language.ts';
import type { Speciality } from '../../routes/booking/book-appointment';
import SpecialtyCard from './specialty-card';

export default function SpecialtyList({
  specialties,
  selectedId,
  onSelect,
}: {
  specialties: Speciality[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}) {
  const { t } = useTranslation();
  const { language } = useLanguage();
  if (specialties.length === 0) {
    return (
      <div className="flex h-full items-center justify-center">
        <p className="text-center text-gray-500">
          {t('booking.specialtySelection.noResults')}
        </p>
      </div>
    );
  }

  return (
    <div className="flex h-[442px] flex-col gap-4 overflow-scroll px-3 pt-2 md:px-6">
      {specialties.map((spec) => {
        const display = getLocalizedSpeciality(spec, language);
        return (
          <SpecialtyCard
            key={spec.id}
            title={display.name}
            description={display.description}
            iconName={spec.name}
            isSelected={selectedId === spec.id}
            onClick={() => onSelect(spec.id)}
          />
        );
      })}
    </div>
  );
}
